import medicationImage from '../assets/images/services/Medication_Reminders.png';
import hygieneImage from '../assets/images/services/Hygiene_Bathing.png';
import groomingImage from '../assets/images/services/Dressing_Grooming.png';
import exerciseImage from '../assets/images/services/Exercise_Activities_of_Daily_Living.png';
import nutritionImage from '../assets/images/services/Hydration_Nutrition.png';
import homemakingImage from '../assets/images/services/Light_Homemaking.png';
import personalCareImage from '../assets/images/services/Extensive_Personal_Care.png';
import dementiaCareImage from '../assets/images/services/Dementia_Alzheimers_Care.png';
import transportationImage from '../assets/images/services/Escorts_to_Dr_Appointments.png';
import shoppingImage from '../assets/images/services/Grocery_Shopping.png';

export interface Service {
  id: number;
  title: string;
  shortDesc: string;
  longDesc: string;
  icon: string;
  image: string;
}

export const services: Service[] = [
  {
    id: 1,
    title: "Medication Reminders",
    shortDesc: "Timely medication management and reminders",
    longDesc: `Medication adherence is critical for maintaining health and independence, with non-compliance
    often being a primary reason for transitioning to a facility. Our dedicated Providers offer
    essential medication reminders, helping clients take their prescriptions correctly and on
    schedule, assisting with reordering, and facilitating pharmacy pickups. For families requiring
    comprehensive medication organization, MASA HILLS Health Services can also provide referrals
    to trusted outside services specializing in medication management and oversight.
    `,
    icon: "💊",
    image: medicationImage,
  },
  {
    id: 2,
    title: "Hygiene and Bathing",
    shortDesc: "Assistance with personal hygiene and bathing",
    longDesc: `Consistent personal hygiene and safe bathing are critical for maintaining health, dignity, and
    preventing infections, with challenges in these personal care tasks often leading to a decline in
    overall well-being and independence. Our compassionate Providers offer respectful and
    dignified assistance with all aspects of personal hygiene, including bathing, showering,
    dressing, grooming, oral care, and toileting, ensuring a safe, comfortable, and private
    experience tailored to individual needs and preferences. We focus on promoting independence
    wherever possible by adapting routines to client abilities and ensuring a meticulously clean and
    secure environment, thereby helping to maintain skin integrity and enhance our clients&#39; quality
    of life.
    `,
    icon: "🚿",
    image: hygieneImage,
  },
  {
    id: 3,
    title: "Dressing and Grooming",
    shortDesc: "Assistance with dressing and personal grooming",
    longDesc: `Maintaining personal appearance and hygiene through proper dressing and grooming is
    fundamental to an individual&#39;s dignity, self - esteem, and overall well - being, significantly impacting
    their comfort and social interaction.Our compassionate Providers offer respectful, hands - on
    assistance with daily dressing routines, including selecting appropriate attire and help with the
    physical aspects of dressing and undressing, alongside support for essential grooming tasks
    such as hair care, oral hygiene, shaving, and other personal care activities, always encouraging
    client independence.MASA HILLS Health Services ensures these intimate tasks are performed
    with the utmost sensitivity, respecting personal preferences and promoting a positive self - image
    for every client we serve.`,
    icon: "👔",
    image: groomingImage,
  },
  {
    id: 4,
    title: "Exercise and Activities of Daily Living",
    shortDesc: "Support with daily activities and exercise",
    longDesc: `Maintaining physical activity and the ability to perform Activities of Daily Living (ADLs) are
    fundamental to preserving independence and quality of life, with decline in these areas often
    contributing to a need for higher levels of care. Our dedicated Providers offer essential support
    with prescribed exercise programs to enhance mobility, strength, and balance, and provide
    respectful, hands-on assistance with personal ADLs such as bathing, dressing, grooming,
    toileting, and transferring. We aim to empower clients by fostering their self-care abilities and
    promoting safety and comfort within their own homes.`,
    icon: "🏃",
    image: exerciseImage,
  },
  {
    id: 5,
    title: "Hydration and Nutrition",
    shortDesc: "Assistance with hydration and nutrition",
    longDesc: `Proper hydration and balanced nutrition are cornerstones of well-being and vitality, especially for
    those managing health conditions at home, with deficiencies often contributing to declining
    health and the need for higher levels of care. Our attentive Providers at MASA HILLS Health
    Services play a crucial role by encouraging adequate fluid intake, assisting with meal planning
    and preparation tailored to dietary needs and preferences, monitoring consumption, and
    ensuring clients have easy access to nourishing foods and beverages. For individuals requiring
    in-depth dietary counseling or medical nutrition therapy, MASA HILLS Health Services can also
    connect you with reputable registered dietitians or nutritionists to develop comprehensive,
    `,
    icon: "🥗",
    image: nutritionImage,
  },
  {
    id: 6,
    title: "Light Homemaking",
    shortDesc: "Support with light housekeeping and homemaking tasks",
    longDesc: `A clean, safe, and comfortable home environment is crucial for overall well-being and supports
    our clients&#39; ability to live independently, easing the daily burdens that can make aging in place a
    challenge. Our dedicated Providers at MASA HILLS Health Services offer valuable light
    homemaking support, which can include tasks such as tidying living areas, assisting with
    laundry and dishes, light meal preparation, vacuuming, and maintaining general cleanliness and
    organization. This service helps ensure a pleasant and hygienic living space, allowing clients to
    focus on their health and enjoy their surroundings, and for more extensive home maintenance
    or deep cleaning needs, we can assist in connecting families with suitable external resources.
    `,
    icon: "🏠",
    image: homemakingImage,
  },
  {
    id: 7,
    title: "Extensive Personal Care",
    shortDesc: "Comprehensive personal care services",
    longDesc: `For individuals requiring more comprehensive support with daily living, our Extensive Personal
    Care service is fundamental to maintaining their dignity, safety, and comfort at home, often
    preventing the need for facility-based care. Our compassionate and skilled Providers offer
    respectful, hands-on assistance tailored to each client&#39;s unique needs, which can include
    bathing, dressing, grooming, toileting, mobility support, feeding, and other essential personal
    tasks. This dedicated care ensures that clients facing significant physical or cognitive challenges
    receive the comprehensive support necessary to enhance their well-being and live as
    independently and comfortably as possible in familiar surroundings.
    `,
    icon: "👥",
    image: personalCareImage,
  },
  {
    id: 8,
    title: "Dementia and Alzheimer's Care",
    shortDesc: "Specialized care for Dementia and Alzheimer's",
    longDesc: `Navigating the complexities of Dementia and Alzheimer’s requires specialized support to ensure
    safety, dignity, and engagement in a familiar home environment, which can significantly alleviate
    family stress and prevent premature transitions to facility care. Our compassionate Providers at
    MASA HILLS Health Services are specially trained to offer dedicated Dementia and Alzheimer’s
    care, focusing on creating secure and consistent routines, managing behavioral symptoms with
    patience and understanding, and assisting with activities of daily living in a way that fosters
    remaining independence and comfort. We provide tailored cognitive stimulation through
    appropriate activities, ensure a safe living space by identifying and mitigating risks, offer crucial
    respite and emotional support for families, and for those requiring advanced clinical
    assessments or specialized therapies beyond our direct services, MASA HILLS Health Services
    can facilitate connections with trusted neurological specialists or community dementia support
    programs.
    `,
    icon: "🧠",
    image: dementiaCareImage,
  },
  {
    id: 9,
    title: "Escorts to Dr. Appointments",
    shortDesc: "Transportation and escorts to medical appointments",
    longDesc: `Ensuring consistent access to medical care is vital for managing health conditions and overall
    well-being, yet transportation and navigating appointments can be challenging for many
    individuals and their families. Our dedicated Providers offer reliable escort services to doctor&#39;s
    appointments, providing safe transportation, assistance with mobility in and out of vehicles and
    clinics, and compassionate companionship throughout the visit. We strive to alleviate the stress
    of appointment logistics, ensuring clients arrive on time and feel supported, and can assist with
    understanding instructions or taking notes if requested, fostering a smoother healthcare
    experience and peace of mind.
    `,
    icon: "🚗",
    image: transportationImage,
  },
  {
    id: 10,
    title: "Grocery Shopping",
    shortDesc: "Assistance with grocery shopping and errands",
    longDesc: `Recognizing that consistent access to nutritious food is fundamental for health and continued
    independence at home, MASA HILLS Health Services offers a dedicated Grocery Shopping
    service to alleviate the challenges some clients face. Our reliable Providers can assist with
    every step, from planning shopping lists based on dietary needs and preferences, to
    accompanying clients to the store or shopping on their behalf, and ensuring all groceries are
    thoughtfully selected, purchased, and properly unpacked and stored upon return. This support
    helps ensure clients have fresh, healthy food available, contributing significantly to their overall
    well-being and ability to remain comfortable in their own homes.
    `,
    icon: "🛒",
    image: shoppingImage,
  }
];
